import React, { useState } from 'react';
import { createPortal } from 'react-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../context/AuthContext';
import { useLocation } from 'react-router-dom';
import AIMultiTabPopup from './AIMultiTabPopup';
import { AI_CONTEXTS } from '../utils/aiContext';
import './FloatingAIButton.css';

const FloatingAIButton = () => {
  const { t } = useTranslation();
  // user used to gate visibility — kept import for AuthContext consumers
  // even though the button is now visible to everyone (guest mode is gated
  // inside AIMultiTabPopup).
  useAuth();
  const location = useLocation();
  const [showAI, setShowAI] = useState(false);
  const [aiContext, setAiContext] = useState(AI_CONTEXTS.DEFAULT);

  const handleOpenAI = () => {
    // Determine context based on current page
    const path = location.pathname;
    let context = AI_CONTEXTS.DEFAULT;

    if (path.includes('/add-recipe') || path.includes('/edit-recipe')) {
      context = AI_CONTEXTS.ADD_RECIPE;
    } else if (path.includes('/recipes/') && !path.includes('/recipes')) {
      context = AI_CONTEXTS.RECIPE_DETAIL;
    } else if (path === '/recipes') {
      context = AI_CONTEXTS.RECIPES;
    } else if (path.includes('/machine') || path.includes('/settings')) {
      context = AI_CONTEXTS.MACHINE_CATALOG;
    } else if (path === '/match') {
      context = AI_CONTEXTS.MATCH;
    } else if (path === '/') {
      context = AI_CONTEXTS.HOME;
    }

    setAiContext(context);
    setShowAI(true);
  };

  // AI button is visible for ALL users (incl. guests) so they can discover the
  // feature. Sending real messages is gated inside <AIMultiTabPopup>.
  // (Previously returned null for guests — that hid the entire value prop.)

  return (
    <>
      {/* Floating AI Button */}
      <div 
        className="ai-floating-button"
        onClick={() => handleOpenAI()}
        role="button"
        aria-label="Åbn SlushBook AI Assistent"
        tabIndex={0}
        onKeyPress={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            handleOpenAI();
          }
        }}
      >
        <img 
          src="/icons/ai-ikon5.png" 
          alt="SlushBook AI" 
          className="ai-icon" 
        />
        <div 
          className="sparkle" 
          style={{ backgroundImage: 'url(/icons/sparkel.png)' }}
        ></div>
      </div>

      {/* AI Multi-Tab Popup */}
      {showAI && createPortal(
        <AIMultiTabPopup
          isOpen={showAI}
          onClose={() => setShowAI(false)}
          context={aiContext}
        />,
        document.body
      )}
    </>
  );
};

export default FloatingAIButton;
